import React, { useEffect, useState } from 'react';
import axios from 'axios';

const OrderHistory = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get('/api/orders', { withCredentials: true });
        setOrders(res.data);
      } catch (err) {
        setError('Захиалгын түүх авахад алдаа гарлаа');
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  if (loading) return <div>Уншиж байна...</div>;
  if (error) return <div style={{color:'red'}}>{error}</div>;

  return (
    <div style={{background:'#fff', color:'#222', borderRadius:8, padding:24, maxWidth:600, margin:'32px auto'}}>
      <h2 style={{marginBottom:16, display:'flex', alignItems:'center', gap:8}}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" style={{verticalAlign:'middle'}} xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="6" width="18" height="12" rx="2" stroke="#222" strokeWidth="1.7"/>
          <path d="M7 10H17M7 14H13" stroke="#222" strokeWidth="1.7" strokeLinecap="round"/>
        </svg>
        Захиалгын түүх
      </h2>
      {orders.length === 0 ? (
        <div>Захиалга олдсонгүй.</div>
      ) : (
        <ul style={{listStyle:'none', padding:0}}>
          {orders.map(order => (
            <li key={order._id} style={{borderBottom:'1px solid #eee', marginBottom:12, paddingBottom:12}}>
              <div style={{display:'flex', alignItems:'center', gap:6}}>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{verticalAlign:'middle'}} xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="5" width="16" height="10" rx="2" stroke="#888" strokeWidth="1.3"/>
                </svg>
                <b>Огноо:</b> {new Date(order.createdAt).toLocaleString()}
              </div>
              <div style={{display:'flex', alignItems:'center', gap:6}}>
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{verticalAlign:'middle'}} xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 10H16M10 4V16" stroke="#888" strokeWidth="1.3" strokeLinecap="round"/>
                </svg>
                <b>Нийт үнэ:</b> {order.total}₮
              </div>
              <div style={{marginTop:4}}>
                <b>Бараанууд:</b>
                <ul style={{margin:0, paddingLeft:16}}>
                  {order.items.map(item => (
                    <li key={item.product?._id || item.product} style={{display:'flex', alignItems:'center', gap:4}}>
                      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" style={{verticalAlign:'middle'}} xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="8" stroke="#aaa" strokeWidth="1.2"/>
                      </svg>
                      {item.product?.name || 'Бараа'} — {item.quantity}ш × {item.price}₮
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OrderHistory;
